<mat-card>
  <mat-card-title>Message</mat-card-title>
  <mat-card-subtitle *ngIf="data?.commentator_obj">{{data?.commentator_obj.first_name}} {{data?.commentator_obj.last_name}} {{data?.commentator_obj.email_pro}}</mat-card-subtitle>
  <mat-card-content>
    <div class="com-container" fxLayout="row wrap">
      <span [innerHtml]="data?.message | newline | safeHtml"></span>
    </div>
  </mat-card-content>
</mat-card>
